import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {concat, Observable, of} from 'rxjs';
import {map, switchMap, toArray} from 'rxjs/operators';
import * as lodash from 'lodash';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseUnitMessageService {

  constructor(
    protected http: HttpClient,
  ) { }

  protected readonly pageSize = '5000';

  protected abstract getSearchModelName(): string;

  protected abstract getUrl(): string;

  protected buildParams(timestampFrom: number, timestampTo: number, enableTrackFilter: boolean): HttpParams {
    const searchModelName = this.getSearchModelName();
    let params = (new HttpParams())
      .append('per-page', this.pageSize)
      .append('sort', 'time')
      .append(searchModelName + '[time_from]', timestampFrom.toString())
      .append(searchModelName + '[time_to]', timestampTo.toString())
    ;
    if (enableTrackFilter) {
      params = params.append(searchModelName + '[filter_coords]', '1');
    }
    return params;
  }
  protected getMessages(timestampFrom: number, timestampTo: number, enableTrackFilter: boolean): Observable<Array<any>> {
    // console.log(this);
    // console.log(this.http);
    const httpParams = this.buildParams(timestampFrom, timestampTo, enableTrackFilter);
    const url = this.getUrl();
    return this.http.get<Array<any>>(url, {params: httpParams, observe: 'response'}).pipe(
      switchMap(
        response => {
          const pageCount = parseInt(response.headers.get('X-Pagination-Page-Count'), 10);
          if (pageCount > 1) {
            const range = lodash.range(2, pageCount + 1) as number[];
            const pageObservables = range.map(
              page => {
                const httpParams2 = this.buildParams(timestampFrom, timestampTo, enableTrackFilter)
                  .append('page', page.toString());
                return this.http.get<Array<any>>(url, {params: httpParams2, observe: 'body'});
              }
            );
            return concat(of(response.body), ...pageObservables);
          } else {
            return of(response.body);
          }
        }
      ),
      toArray(),
      map(arrays => [].concat(...arrays))
    );
  }
}
